import {connect} from 'react-redux';
import ContentHubComponent from './ContentHub';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {TABLET_BREAKPOINT} from '../../utils/constants';

import {
    pushHandlerClickData,
    pushHandleNextData,
    pushHandlePrevData,
    ACTION_LOCATION,
} from './events';

function mapStateToProps({
    modules: {contentHubData},
    destination: {
        details: {lbsId},
    },
    options: {showContentHub},
}) {
    return {
        contentHubData,
        pushHandleNextData,
        pushHandlePrevData,
        pushHandlerClickData,
        lbsId,
        ACTION_LOCATION,
        showContentHub,
    };
}

export const ContentHub = connect(mapStateToProps)(
    determineIfMobile(ContentHubComponent, TABLET_BREAKPOINT)
);

ContentHub.displayName = 'ContentHub';

export default ContentHub;
